var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('p',[_vm._v("Сумма")]),_c('p',[_c('span',[_vm._v(_vm._s(_vm._f("moneyFormat")(_vm.summVuex)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }